// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2feIA","pin":"pin__2SV22"};